module.exports = __webpack_public_path__ + "Surface_Pro_4_icon.svg?fee64a95d28eafb52c753e834d01b354";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/Surface_Pro_4_icon.svg
// module id = 214
// module chunks = 0